import { ReactElement } from 'react';
import { ModernizationUnitIcon } from 'icons';
import ReactTooltip from 'react-tooltip';
import { BadgeContainer } from './styles';
import { t } from 'i18next';

interface BadgeProps {
  label: string;
  changed_by?: string;
}

export function Badge({
  label,
  changed_by,
}: Readonly<BadgeProps>): ReactElement {
  return (
    <>
      <BadgeContainer {...(changed_by && { 'data-tip': true, 'data-for': 'badge-changed-by' })}>
        <ModernizationUnitIcon size={20} />
        <span>{label}</span>
      </BadgeContainer>
      {changed_by && (
        <ReactTooltip id="badge-changed-by" effect="solid" delayHide={100}>
          <span>
            {t('ultimoStatusAlteradoPor')}
            {changed_by}
          </span>
        </ReactTooltip>
      )}
    </>
  );
}
